import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Legend,
} from "recharts";

type PlanUsageSeries = {
  plan: string;
  data: number[];
};

interface PlanUsageChartProps {
  labels: string[];
  series: PlanUsageSeries[];
}

const COLORS = [
  "#6366F1",
  "#14B8A6",
  "#F59E0B",
  "#EF4444",
  "#3B82F6",
  "#8B5CF6",
  "#10B981",
];

const PlanUsageChart: React.FC<PlanUsageChartProps> = ({ labels, series }) => {
  const chartData = useMemo(() => {
    return labels.map((label, index) => {
      const point: Record<string, string | number> = { label };
      series.forEach((item) => {
        point[item.plan] = item.data[index] ?? 0;
      });
      return point;
    });
  }, [labels, series]);

  return (
    <div className="mt-4 h-56 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#E5E7EB" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              borderColor: "#E5E7EB",
              fontSize: "12px",
            }}
            labelStyle={{ fontWeight: 600 }}
          />
          <Legend
            verticalAlign="top"
            align="left"
            wrapperStyle={{ fontSize: "12px" }}
          />
          {series.map((item, index) => (
            <Line
              key={item.plan}
              type="monotone"
              dataKey={item.plan}
              stroke={COLORS[index % COLORS.length]}
              strokeWidth={2}
              dot={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PlanUsageChart;
